import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const RefreshLink = props => /*#__PURE__*/_jsx(Link, Object.assign({
  onClick: () => window.location.reload()
}, props));
export default RefreshLink;